module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.applyDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.businessName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.useReason))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报送单位")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.sendUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("文件名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.fileNames))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fileNumber))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("文件类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fileType))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("拟用章")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showImg(1)
      }
    }
  }, [_vm._v("查看")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章数量")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sealNumber))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否业务盖章")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isBusinessSeal))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("登记人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.registerName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("登记日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.registerDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("盖章信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sealStaffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sealDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("盖章备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.sealRemark))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("送出信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("送出人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sendStaffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("送出时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sendDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("送出备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.sendRemark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80621974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/attendance/sealBusiness.vue
// module id = 05ZE
// module chunks = 0